import { render, staticRenderFns } from "./ProdutoEditModal.vue?vue&type=template&id=67d2d966&scoped=true"
import script from "./ProdutoEditModal.vue?vue&type=script&lang=js"
export * from "./ProdutoEditModal.vue?vue&type=script&lang=js"
import style0 from "./ProdutoEditModal.vue?vue&type=style&index=0&id=67d2d966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d2d966",
  null
  
)

export default component.exports